import React from "react";
import { useTranslation } from "react-i18next";

import { Zone } from "@planzone/dto";
import { useZoneEdition } from "@planzone/view-models";
import { Modal } from "@common/modal";
import { Button } from "@common/button";
import { ZoneEditionForm } from "./zoneEditionForm";
import { Props } from "./types";
import styles from "./styles.scss";

function ZoneEdition(props: Props) {
  const { t } = useTranslation();
  const { isRequestPending, editZone } = useZoneEdition();
  const [zone, setZone] = React.useState<Zone>(props.zone);

  return (
    <Modal
      header={t("zoneEdition.title", { name: props.zone.name })}
      close={props.cancel}
    >
      <div className={styles.zoneEdition}>
        <div className={styles.main}>
          <div className={styles.form}>
            <ZoneEditionForm zone={zone} editForm={setZone} />
          </div>
          <div className={styles.buttons}>
            <Button type="cancel" press={props.cancel}>
              {t("zoneEdition.cancel")}
            </Button>
            <Button
              type="submit"
              status={isRequestPending ? "pending" : "none"}
              press={() => editZone({ zone: props.zone, nextZone: zone })}
            >
              {t("zoneEdition.save")}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export { ZoneEdition };
